import base_ds, {CrudOperates} from '@/services/base_datasource_service'
import DataSource from 'devextreme/data/data_source';
import {BaseEntity, IResponseResult} from './base_types';
import {AxiosResponse} from 'axios';

export const route_ns = 'admin/role'

export class UserRole extends BaseEntity {
  name: string = ''
  description: string = ''
}

class entityClass extends UserRole {}

class UserRoleManagerService {
  dataSource: DataSource;
  roleCrud: CrudOperates;

  public selected_row: any = null;

  public edit_popup: any = {
    visible: false,
    edit_mode: false,
  }

  public roles = [
    {
      id: 'bc91ad0b-75aa-42ec-8f51-116e6e29c8c0',
      description: 'Администратор'
    },
    {
      id: '18cecd34-f44c-4890-8a4b-b9e389739bfe',
      description: 'Оператор'
    },

  ];

  constructor() {
    this.dataSource = base_ds.getBaseDataSource(route_ns);
    this.roleCrud = base_ds.getBaseCrud(route_ns);
  }

  public async save(entity: entityClass): Promise<IResponseResult<UserRole>> {
    const response: AxiosResponse['data'] = await this.roleCrud.save(entity);
    if (response && response.status === 'success' && response.totalCount === 1) {
      return {data: (response.data as UserRole)};
    } else if (response && response.message) {
      return {data: null, message: response.message};
    }
    return {data: null, message: ''};
  }

  async deleteUserRole(role: UserRole) {
    return this.roleCrud.delete(role.id);
  }

  setEditPopupVisible(vis: boolean) {
    this.edit_popup.visible = vis;
  }

  setEditPopupMode(vis: boolean) {
    this.edit_popup.edit_mode = vis;
  }

  setCurrentRow(data: UserRole | null) {
    this.selected_row = data;
  }
}

export default new UserRoleManagerService();
